import React from 'react';
import PropTypes from 'prop-types';
import { constant, mapObject } from 'underscore';
import classNames from 'classnames';
import { Glyphicon, Button } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getMenuItemStyles } from '../styles/menu-item-styles';

const GetNodeClassNames = (node, classes) => classNames([
  classes.baseMenuItem,
  node.isSelected ? [classes.selectedMenuItem, 'selected'] : classes.normalMenuItem,
  `menu-item-${node.Id}`,
]);

const ImportTypeItem = ({
  classes,
  node,
  renderText,
  onItemClick,
}) => {
  const cnames = classNames([GetNodeClassNames(node, classes)]);

  return (
    <Button
      key={node.Id}
      className={cnames}
      btnStyle="command"
      onClick={() => onItemClick(node)}
      aria-label={node.Name}
    >
      {node.isSelected && <div className={classes.beforeIcon} />}
      <div className={classes.iconContainer}>
        <Glyphicon
          id={`${node.glyphIconName}-icon`}
          className={classes.typeSelectionIcon}
          glyph={node.glyphIconName}
        />
      </div>
      {renderText && <span className={classNames(classes.textContainer, 'type-name')}>{renderText}</span>}
    </Button>
  );
};

ImportTypeItem.propTypes = {
  classes: PropTypes.shape(mapObject(
    getMenuItemStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  node: PropTypes.shape({
    Id: PropTypes.string,
    Name: PropTypes.string,
    glyphIconName: PropTypes.string,
    isSelected: PropTypes.bool,
  }).isRequired,
  renderText: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
};

ImportTypeItem.defaultProps = {
  renderText: null,
};

export default withDefaultStyles(ImportTypeItem, getMenuItemStyles);
